export const locations = [
    "Kochi",
    "Cochin",
    "Calicut",
    "Kozhikode",
    "Palakkad",
    "Kannur",
    "Kottayam",
    "Thrissur",
    "Ernakulam",
    "Trivandrum",
    "Kollam",
    "Malappuram",
    "Wayanad",
    "Manjeri",
    "Perinthalmanna",
    "Aluva",
    "Angamaly",
    "Pala",
    "Pathanamthitta",
    "Aroor",
    "Alappuzha",
    "Idukki"
  ];
  